import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import priceData from "../../Components/Price/PriceLogic";
import { useTranslation } from "react-i18next";
import { getAllPlans } from "../../../../services/billing";
import PackageSummaryModal from "../../../Layout/DashboardLayout/Razorpay/PackageSummaryModal";
import RazorpayModal from "../../../Layout/DashboardLayout/Razorpay/RazorpayModal";
import { useRazorpay } from "../../../../context/RazorpayContext";
import PriceSectionCardSkeleton from "../Skeleton/PricingSkeleton";
import NoPlansAvailable from './NoPlanAvailable';
import DescriptionList from '../../../../common/DescriptionList';
import Testimonial from '../Testimonials/Testimonial';
import { pricBg } from '../../../../../images';
import SEO from '../../../../SEO/Seo';
import { metaContent } from '../../../../SEO/metaContent';
import EnterprisePlanModal from '../../../Layout/DashboardLayout/BillingDashboard/modals/EnterprisePlanModal';

const Price = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { invoiceModalData, razorpayModalData, handlePreviewPlan } = useRazorpay();
  const [plans, setPlans] = useState(null);
  const [isNoPlanAvailable, setIsNoPlanAvailable] = useState(false);
  const [loading, setLoading] = useState(true);
  const { title, heading, subheading } = priceData[location.pathname] || priceData["/"];
  const [traceBtnClick, setTraceBtnClick] = useState({ isLoading: false, btnClickPackageId: null });
  const afterPaymentSuccessNavigationUrl = '/dashboard';
  const numberOfWebSkeletonCard = 3;
  const isMetaTag = location.pathname === "/pricing";
  const [showEnterpriseModal, setShowEnterpriseModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);


  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await getAllPlans();
        const apiPlans = response?.data?.data;
        setPlans(apiPlans);
        if (!apiPlans?.length) setIsNoPlanAvailable(true);
        const platinumExists = apiPlans.some(p => p.name === "Platinum");

        if (!platinumExists && location.pathname === "/pricing" || location.pathname === "/") {
          apiPlans.push({
            id: "platinum-default",
            name: "Enterprise",
            price: "Enterprise",
            interval: "monthly",
            description: "For Big Brands Complete control & team collaboration Everything in Starter, plus\nCustom Integrations & Reports\nTeam Roles & Permissions\nDedicated account manager support\nQuarterly growth strategy review\nBest for large brands, distributors & agencies",
            isPopular: true
          });
        }

        setPlans(apiPlans);

        // Set default selected plan → Platinum if available
        const defaultPlan = apiPlans.find(p => p.name === "Platinum") || apiPlans[0];
      } catch (err) {
        setIsNoPlanAvailable(true);
        console.error('Failed to fetch plans: ', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  if (isNoPlanAvailable) return <NoPlansAvailable />;

  useEffect(() => {
    // ✅ Select the static container
    const staticContainer = document.querySelector(".static-container");
    if (!staticContainer) return; // safeguard if not found

    // 🟢 Save old background before changing
    const oldBackground = staticContainer.style.backgroundImage;
    const oldBgColor = staticContainer.style.backgroundColor;
    const oldBgSize = staticContainer.style.backgroundSize;
    const oldBgRepeat = staticContainer.style.backgroundRepeat;
    const oldBgPosition = staticContainer.style.backgroundPosition;
    const oldBgAttachment = staticContainer.style.backgroundAttachment;

    // 🟣 Apply About Us background image
    staticContainer.style.backgroundImage = `url(${pricBg})`;
    staticContainer.style.backgroundSize = "cover";
    staticContainer.style.backgroundRepeat = "no-repeat";
    staticContainer.style.backgroundPosition = "center";
    // staticContainer.style.backgroundAttachment = "fixed";
    staticContainer.style.transition = "background 0.5s ease-in-out";

    // 🔴 Cleanup: restore old background when leaving AboutUs
    return () => {
      staticContainer.style.backgroundImage = oldBackground;
      staticContainer.style.backgroundColor = oldBgColor;
      staticContainer.style.backgroundSize = oldBgSize;
      staticContainer.style.backgroundRepeat = oldBgRepeat;
      staticContainer.style.backgroundPosition = oldBgPosition;
      staticContainer.style.backgroundAttachment = oldBgAttachment;
    };
  }, []);

  const renderModernDesign = () => (
    <div className="modern-price-container">
      <div className="text-center">
        <h2 className="hero-heading text-white">{heading}</h2>
        <p className="hero-heading price-gradient-text mt-1">{subheading}</p>
        <p className="hero-sub-text mt-1">Invest in Insights That Guarantee Growth</p>
      </div>

      {/* Pricing Cards */}
      <div className={plans?.length >= 3 ? "pricing-large-container" : plans?.length === 1 ? "pricing-container-one " : "pricing-container"}>
        <div className="pricing-grid">
          {loading
            ? [...Array(numberOfWebSkeletonCard)].map((_, i) => <PriceSectionCardSkeleton key={i} />)
            : plans?.map(plan => (
              <div key={plan.id} className={`modern-pricing-card ${plan.isPopular ? 'popular-card' : ''}`}>
                <div className="text-center"><p className='modern-plan-badge'>{plan.name}</p></div>
                <div className="modern-plan-price">
                  <h2 className="price-amount">{plan.price}{!plan?.isPopular && (<span style={{ fontSize: '25px' }}>  /{plan?.interval || ""}</span>)}</h2>
                  <DescriptionList description={plan.description} className={"text-white mb-2"} />
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    className={`modern-buy-btn ${plan?.isPopular ? 'popular-btn' : 'standard-btn'}`}
                    onClick={(e) => {
                      if (plan.isPopular) {
                        setSelectedPlan(plan);
                        setShowEnterpriseModal(true);
                      } else {
                        handlePreviewPlan(e, plan?.id, 'plan', setTraceBtnClick, false);
                      }
                    }} disabled={traceBtnClick?.isLoading}
                  >
                    {plan.isPopular ? "Contact Now" : "Buy Now"}
                  </button>

                  <button
                    className={`modern-buy-btn ${plan?.isPopular ? 'popular-btn' : 'standard-btn'}`}
                    onClick={(e) => {
                      if (plan.isPopular) {
                        setSelectedPlan(plan);
                        setShowEnterpriseModal(true);
                      } else {
                        handlePreviewPlan(e, plan?.id, 'plan', setTraceBtnClick, false);
                      }
                    }}
                    disabled={traceBtnClick?.isLoading}>
                    {plan.isPopular ? "Contact Now" : "Buy Now"}
                  </button>
                </div>
                <div className="modern-features-list">
                  <ul className="features-ul">
                    {plan?.features?.map((feature, idx) => (
                      <li key={idx} className="feature-item">
                        <span className="feature-bullet"></span>
                        <span className="feature-text">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="plan-tagline">{plan.tagline}</div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  const renderAlternateDesign = () => (
    <div className="py-5 ">
      <div className="text-start price-text-container text-center">
        <h2 className="hero-heading price-gradient-text text-white">{heading}</h2>
        <p className="hero-heading text-white mt-1">{subheading}</p>
        <p className="hero-sub-text mt-1 text-center">Invest in Insights That Guarantee Growth</p>
      </div>

      {/* Pricing Cards */}
      <div className={plans?.length >= 3 ? "pricing-large-container" : "pricing-container"}>
        <div className="pricing-grid">
          {loading
            ? [...Array(numberOfWebSkeletonCard)].map((_, i) => <PriceSectionCardSkeleton key={i} />)
            : plans?.map(plan => (
              <div key={plan.id} className={`modern-pricing-card ${plan.isPopular ? 'popular-card' : ''}`}>
                <div className="text-center"><p className='modern-plan-badge'>{plan.name}</p></div>
                <div className="modern-plan-price">
                  <h2 className="price-amount">{plan.price}{!plan?.isPopular && (<span style={{ fontSize: '25px' }}>  /{plan?.interval || ""}</span>)}</h2>
                  <DescriptionList description={plan.description} className={"text-white mb-2"} />
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    className={`modern-buy-btn ${plan?.isPopular ? 'popular-btn' : 'standard-btn'}`}
                    onClick={(e) => {
                      if (plan.isPopular) {
                        setSelectedPlan(plan);
                        setShowEnterpriseModal(true);
                      } else {
                        handlePreviewPlan(e, plan?.id, 'plan', setTraceBtnClick, false);
                      }
                    }}
                    disabled={traceBtnClick?.isLoading}
                  >
                    {plan.isPopular ? "Contact Now" : "Buy Now"}
                  </button>

                  <button
                    className={`modern-buy-btn ${plan?.isPopular ? 'popular-btn' : 'standard-btn'}`}
                    onClick={(e) => {
                      if (plan.isPopular) {
                        setSelectedPlan(plan);
                        setShowEnterpriseModal(true);
                      } else {
                        handlePreviewPlan(e, plan?.id, 'plan', setTraceBtnClick, false);
                      }
                    }}
                    disabled={traceBtnClick?.isLoading}>
                    {plan.isPopular ? "Contact Now" : "Buy Now"}
                  </button>
                </div>
                <div className="modern-features-list">
                  <ul className="features-ul">
                    {plan?.features?.map((feature, idx) => (
                      <li key={idx} className="feature-item">
                        <span className="feature-bullet"></span>
                        <span className="feature-text">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="plan-tagline">{plan.tagline}</div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <Testimonial />
    </div>
  );

  return (
    <>
      {/* Meta tags  */}
      {isMetaTag && (
        <SEO {...metaContent.pricing} />
      )}



      {showEnterpriseModal && (
        <EnterprisePlanModal
          plan={selectedPlan}
          onClose={() => setShowEnterpriseModal(false)}
        />

      )}
      {invoiceModalData?.isInvoiceDetailsModal && (
        <PackageSummaryModal packageType={'plan'} showCoupen={true}/>
      )}

      {razorpayModalData?.isRazorPayModal && (
        <RazorpayModal navigationUrl={afterPaymentSuccessNavigationUrl} />
      )}

      {/* Conditional layout rendering */}
      {location.pathname === "/pricing" ? renderAlternateDesign() : renderModernDesign()}
    </>
  );
};

export default Price;